import { useMutation, UseMutationResult, useQuery, useQueryClient, UseQueryResult } from "@tanstack/react-query"
import { carrotClient } from "../../utils/CarrotClient"
import ResponseError from "../../types/responseError"
import { SocialDeterminantsOfHealth } from "../../types/socialDeterminantsOfHealth"
import buildCarrotApiRetryPolicy from "../../utils/CarrotApiRetryPolicy"
import { HttpErrors } from "../../utils/HttpErrors"

const SDOH_QUERY_KEY = "sdohQueryKey"

export function useSocialDeterminantsOfHealthQuery(
  routingInfoId: number
): UseQueryResult<SocialDeterminantsOfHealth, ResponseError> {
  return useQuery(
    [SDOH_QUERY_KEY],
    async () => {
      try {
        return await carrotClient.getSocialDeterminantsOfHealthInRouting(routingInfoId)
      } catch (error) {
        if (error instanceof ResponseError && error.name === HttpErrors.NOT_FOUND) {
          return null
        }
        throw error
      }
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: buildCarrotApiRetryPolicy(1),
      staleTime: 30000
    }
  )
}

export function useSocialDeterminantsOfHealthMutation(): UseMutationResult {
  const queryClient = useQueryClient()
  return useMutation(
    async (payload: SocialDeterminantsOfHealth) => {
      await carrotClient.setSocialDeterminantsOfHealth(payload)
    },
    {
      onSuccess: () => queryClient.refetchQueries([SDOH_QUERY_KEY]),
      retry: buildCarrotApiRetryPolicy(1)
    }
  )
}
